/**
 * Shared labels and helpers for the klubbdrift (shooting-club operations) module:
 * club weapon maintenance, ammo purchases, range inspections and club keys.
 * Keep in sync with backend/lib/club-weapons.js and backend/lib/club-keys.js.
 */
export const MAINTENANCE_TYPES = [
    { key: 'cleaned', label: 'Pusset' },
    { key: 'repaired', label: 'Reparert' },
    { key: 'sentToGunsmith', label: 'Sendt til børsemaker' },
    { key: 'returnedFromGunsmith', label: 'Tilbake fra børsemaker' },
    { key: 'moved', label: 'Flyttet' },
    { key: 'inspected', label: 'Kontrollert' },
];

export const KEY_TYPES = [
    { key: 'key', label: 'Nøkkel' },
    { key: 'card', label: 'Nøkkelkort' },
    { key: 'fob', label: 'Brikke' },
];

export function typeLabel(list, key) {
    const found = (list || []).find(item => item.key === key);
    return found ? found.label : key;
}

export function statusBadgeClass(status) {
    if (status === 'available') {
        return 'bg-success';
    }
    if (status === 'loanedOut') {
        return 'bg-warning text-dark';
    }
    if (status === 'atGunsmith') {
        return 'bg-secondary';
    }
    return 'bg-secondary';
}

export function statusLabel(status) {
    if (status === 'available') {
        return 'Ledig';
    }
    if (status === 'loanedOut') {
        return 'Utlånt';
    }
    if (status === 'atGunsmith') {
        return 'Hos børsemaker';
    }
    return '';
}

export function formatDate(value) {
    if (!value) {
        return '';
    }
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) {
        return '';
    }
    const pad = n => String(n).padStart(2, '0');
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
}

export function todayIso() {
    const d = new Date();
    const pad = n => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
